import { post, read } from '@/utils/request';
import type { ListData } from 'bv-typings';
import { toggleTime } from '@/utils';
import { isArray } from 'bv-validator';
import type { IFbBatchInfo } from '@/types/batch/facebook';
import type { IFacebookBatchProcessing } from './interface';

export const categoryMap = {
  recharge: 'spend_cap',
  bm: 'binding_bm',
  pixel: 'pixel_account',
  rename: 'change_name',
  permission: 'user_permission',
};

export type IBatchProcessingCategory =
  | 'spend_cap'
  | 'change_name'
  | 'user_permission'
  | 'binding_bm'
  | 'pixel_account';

export type IBatchProcessingType = 'recharge' | 'bm' | 'pixel' | 'rename' | 'permission' | '';

export type IGetBatchProcessingListParams = {
  category?: IBatchProcessingCategory;
  start?: string;
  end?: string;
  accountId?: string;
  accountName?: string;
  accountStatus?: string; // 多选
  submitter?: string;
  status?: string; // 多选
  type?: string; // 多选
};

export type IBatchProcessingListRes = ListData<IFbBatchInfo>;

async function getList(params?: IGetBatchProcessingListParams, type?: IBatchProcessingType) {
  return read<IBatchProcessingListRes>(
    'user_account/fb_batch_list',
    toggleTime({ ...params, category: categoryMap[type as string] }),
    // '查询列表失败'
  );
}

export type IGetUnconfirmed = {
  bindingBm: number;
  changeName: number;
  pixelAccount: number;
  spendCap: number;
  userPermission: number;
};
async function getUnconfirmed() {
  return read<IGetUnconfirmed>('user_account/unconfirmed_count', undefined, '查询待办失败');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function batchConfirm(params: any, type?: IBatchProcessingType) {
  return post(
    'user_account/fb_batch_confirm',
    { ...params, category: categoryMap[type as string] },
    '批量确认失败',
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function batchReject(params?: any, type?: IBatchProcessingType) {
  return post(
    'user_account/fb_batch_disapproved',
    { ...params, category: categoryMap[type as string] },
    '批量驳回失败',
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function batchDelete(params: any, type?: IBatchProcessingType) {
  return post(
    'user_account/fb_batch_remove',
    { ...params, category: categoryMap[type as string] },
    '批量删除失败',
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toggleBatchOperateParams = (params: any, type: IBatchProcessingType) => {
  if (isArray(params)) {
    return params;
  }
  if (type === 'pixel') {
    return [{ ...params, pixelId: params.pixel }];
  }
  // if (type === 'bm') {
  //   return [ { ...params, business: params.bmId } ]
  // }
  return [params];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function batchCommit(params: any, type: IBatchProcessingType, signal?: any) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return post<any>(
    'user_account/fb_batch_commit',
    { datas: toggleBatchOperateParams(params, type), category: categoryMap[type as string] },
    '创建申请失败',
    undefined,
    { signal },
  );
}

export type IGetAccountInfo = {
  accountId: string;
  accountName: string;
  accountStatus: number;
  amountSpent?: string;
  bindedBm?: string;
  lowerLimit?: string;
  spendCap?: string;

  /** 是否在封禁池 */
  isDisabled: IFacebookBatchProcessing.Common.InDisabled;
  /** 余额 */
  balance: number;
  /** 业务线 */
  belong: string;
};
async function getAccountInfo(accountId?: string) {
  return read<IGetAccountInfo>('user_account/fb_account_info', { accountId }, '获取账户信息失败');
}

export type IGetBmInfo = {
  bmId: string;
  bmName: string;
};

async function getBmInfo(bmId?: string) {
  return read<IGetBmInfo>('user_account/fb_bm_info', { bmId }, '获取BM信息失败');
}

export type IGetPixelInfo = {
  isBluefocus: number;
  ownerBusiness: string;
  pixelId: string;
  pixelName: string;
};

async function getPixelInfo(pixelId?: string) {
  return read<IGetPixelInfo>('user_account/fb_pixel_info', { pixelId }, '获取像素信息失败');
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function batchOperate(params: any, type?: IBatchProcessingType, signal?: any) {
  return post(
    'user_account/fb_batch_pro',
    { fileData: params, category: categoryMap[type as string] },
    '批量查询信息失败',
    undefined,
    { signal },
  );
}

export {
  getList,
  getUnconfirmed,
  batchConfirm,
  batchReject,
  batchDelete,
  getAccountInfo,
  getBmInfo,
  getPixelInfo,
  batchCommit,
  batchOperate,
};
